import React, { useState } from 'react';
import Modal from 'components/ui/Modal';

export interface TreeOption {
    id: string | null;
    name: string;
}

interface Props {
    trees: TreeOption[];
    onConfirm: (selectedTreeId: string | null) => void;
    onClose: () => void;
    isAdding: boolean;
}

export default function AddToTreeModal({ trees, onConfirm, onClose, isAdding }: Props) {
    const [selectedId, setSelectedId] = useState<string | null>(
        trees.length === 1 ? trees[0].id : null,
    );

    const handleConfirm = () => {
        if (selectedId !== null || trees.some((t) => t.id === null)) {
            onConfirm(selectedId);
        }
    };

    const canConfirm = trees.some((t) => t.id === selectedId) && !isAdding;

    return (
        <Modal
            title='Add Opportunities to Tree'
            onClose={onClose}
            closeOnOverlayClick={!isAdding}
            className='add-to-tree-modal'
        >
            <p className='add-to-tree-modal__description'>
                Select the tree to add the suggested opportunities to.
                Hierarchy will be preserved using connectors.
            </p>
            <div className='add-to-tree-modal__list'>
                {trees.map((tree) => (
                    <label key={String(tree.id)} className='add-to-tree-modal__option'>
                        <input
                            type='radio'
                            name='tree-select'
                            value={String(tree.id)}
                            checked={selectedId === tree.id}
                            onChange={() => setSelectedId(tree.id)}
                            disabled={isAdding}
                        />
                        <span className='add-to-tree-modal__option-name'>{tree.name}</span>
                    </label>
                ))}
            </div>
            <div className='add-to-tree-modal__footer'>
                <button
                    className='add-to-tree-modal__btn add-to-tree-modal__btn--cancel'
                    onClick={onClose}
                    disabled={isAdding}
                >
                    Cancel
                </button>
                <button
                    className='add-to-tree-modal__btn add-to-tree-modal__btn--confirm'
                    onClick={handleConfirm}
                    disabled={!canConfirm}
                >
                    {isAdding ? 'Adding…' : 'Add to Tree'}
                </button>
            </div>
        </Modal>
    );
}
